import { createActions, using } from "redux-box";

export default createActions({
  requestDocumentFileList: using("page"),
  requestConcatDocumentFileList: using("page"),
  createDocumentFile: using("data"),
  updateDocumentFile: using("data"),
  setActiveDocumentFile: using("upload"),
  setDocumentFileEditMode: using("value"),
  setDocumentFileError: using("value"),
  clearDocumentFileFormState: using(),
});
